import { render, staticRenderFns } from "./GovProposalDetail.vue?vue&type=template&id=59ef3e6c&"
import script from "./GovProposalDetail.vue?vue&type=script&lang=js&"
export * from "./GovProposalDetail.vue?vue&type=script&lang=js&"
import style0 from "./GovProposalDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports